import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/home'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters.isAuthenticated) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('AUTH_LOGOUT')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/products',
    name: 'products',
    meta: { authRequired: true },
    component: () => import('./views/products/Products')
  },
  {
    path: '/complements',
    name: 'complements',
    meta: { authRequired: true },
    component: () => import('./views/products/Complements')
  },
  {
    path: '/complements-groups',
    name: 'complements-groups',
    meta: { authRequired: true },
    component: () => import('./views/products/ComplementsGroups')
  },
  {
    path: '/categories',
    name: 'categories',
    meta: { authRequired: true },
    component: () => import('./views/products/Categories')
  },
  {
    path: '/categories/edit/:id?',
    name: 'category',
    meta: { authRequired: true },
    component: () => import('./views/products/Category')
  },
  {
    path: '/category-groups',
    name: 'category-groups',
    meta: { authRequired: true },
    component: () => import('./views/products/CategoryGroups')
  },
  {
    path: '/category-groups/edit/:id?',
    name: 'category-group',
    meta: { authRequired: true },
    component: () => import('./views/products/CategoryGroup')
  },
  {
    path: '/products/edit/:id?', 
    name: 'product',
    meta: { authRequired: true },
    component: () => import('./views/products/Product')
  },
  {
    path: '/users',
    name: 'users',
    meta: { authRequired: true },
    component: () => import('./views/users/Users')
  },
  {
    path: '/sales',
    name: 'sales',
    meta: { authRequired: true },
    component: () => import('./views/sales/Sales')
  },
  {
    path: '/sales/detail/:id',
    name: 'sale',
    meta: { authRequired: true },
    component: () => import('./views/sales/Sale'),
  },
  {
    path: '/notifications',
    name: 'notifications',
    meta: { authRequired: true },
    component: () => import('./views/notifications/Notifications')
  },
  {
    path: '/agents',
    name: 'agents',
    meta: { authRequired: true },
    component: () => import('./views/agents/Agents')
  },
  {
    path: '/agents/edit/:id?',
    name: 'agent',
    meta: { authRequired: true },
    component: () => import('./views/agents/Agent')
  },
  {
    path: '/settings',
    name: 'settings',
    meta: { authRequired: true },
    component: () => import('./views/settings/Settings')
  },
  {
    path: '/settings/import',
    name: 'import-products',
    meta: { authRequired: true },
    component: () => import('./views/settings/Import')
  },
  {
    path: '/settings/store',
    name: 'store',
    meta: { authRequired: true },
    component: () => import('./views/settings/Store')
  },
  {
    path: '/settings/messages',
    name: 'messages',
    meta: { authRequired: true },
    component: () => import('./views/settings/Messages')
  },
  {
    path: '/settings/layout',
    name: 'layout',
    meta: { authRequired: true },
    component: () => import('./views/settings/Layout')
  },
  {
    path: '/settings/shipping',
    name: 'shipping',
    meta: { authRequired: true },
    component: () => import('./views/settings/Shipping')
  },
  {
    path: '/settings/working-hours',
    name: 'working-hours',
    meta: { authRequired: true },
    component: () => import('./views/settings/WorkingHours')
  },
  {
    path: '/banners',
    name: 'banners',
    meta: { authRequired: true },
    component: () => import('./views/banners/Banners')
  },
  {
    path: '/coupons',
    name: 'coupons',
    meta: { authRequired: true },
    component: () => import('./views/coupons/Coupons')
  },
  {
    path: '/board',
    name: 'board',
    meta: { authRequired: true },
    component: () => import('./views/board/Board')
  },
  {
    path: '/customers',
    name: 'customers',
    meta: { authRequired: true },
    component: () => import('./views/customers/Customers')
  },
  {
    path: '/customers/:id',
    name: 'customer',
    meta: { authRequired: true },
    component: () => import('./views/customers/Customer')
  },
  {
    path: '/reports/products-sales',
    name: 'products-sales',
    meta: { authRequired: true },
    component: () => import('./views/reports/ProductsSales')
  },
  {
    path: '/reports/abandoned-cart',
    name: 'abandoned-cart',
    meta: { authRequired: true },
    component: () => import('./views/reports/AbandonedCart')
  },
]
